<div v-if="options">
	<span v-html="changeLog.log"/>
</div>
